import React, { useState } from 'react';
import { FormInstance } from 'antd/es/form';
import { useRecoilValue } from 'recoil';
import SharingInterviewForm from 'components/community/parts/SharingInterviewForm';
import { interviewFirmInfoState } from 'modules/community/recoilState';
import { Checkbox, Form } from 'antd';
import styled from 'styled-components';
import { device } from 'GlobalStyles';

type TInterviewContentsWriteProps = {
  form: FormInstance;
};

const InterviewContentsWrite = ({ form }: TInterviewContentsWriteProps) => {
  const interviewFirmInfo = useRecoilValue(interviewFirmInfoState);
  const [checkedRoundList, setCheckedRoundList] = useState([1]);

  const onChangeChecked = () => {
    setCheckedRoundList(
      form.getFieldValue('interview_round_checkboxes').sort(function(a: number, b: number) {
        return a - b;
      }),
    );
  };

  return (
    <InterviewContentsWriteWrapper>
      <div className='checkBoxes'>
        <Form.Item name='interview_round_checkboxes' initialValue={[1]}>
          <Checkbox.Group onChange={onChangeChecked}>
            {[1, 2, 3, 4, 5, 6, 7].map((num: number, index: number) => (
              <Checkbox
                className='green-border-checkbox'
                value={num}
                key={index}
                style={{ pointerEvents: num === 1 ? 'none' : 'unset' }}
              >
                {num}차 인터뷰
              </Checkbox>
            ))}
          </Checkbox.Group>
        </Form.Item>
      </div>
      {/* Form.List 안에 체크박스 함께 관리*/}
      <SharingInterviewForm
        isConsultingFirm={interviewFirmInfo.isConsultingFirm}
        form={form} //From.List 사용할 때 getFieldsValue해주기위해
        checkedRound={checkedRoundList}
        boardName={'interviewReview'}
        totalRound={7} //총 인터뷰 라운드
      />
    </InterviewContentsWriteWrapper>
  );
};

export default InterviewContentsWrite;

const InterviewContentsWriteWrapper = styled.div`
  .checkBoxes {
    margin-bottom: 30px;

    .ant-checkbox-wrapper {
      margin: 7px 0;
      width: 24%;
      font-size: 16px;
      @media screen and ${device.lg} {
        width: 30%;
      }
      @media screen and ${device.xs} {
        width: 50%;
      }
    }
  }
`;
